// Schreiben-Assistent Etappe 3: Druckstapel fürs Büro – Schreiben mit Zustellweg „Druck“, die noch nicht erledigt
// sind. Das Büro druckt (einzeln oder alle als ein PDF), unterschreibt von Hand, versendet selbst und hakt ab –
// bei Einschreiben mit Sendungsnummer (Zustellnachweis).
import { supabase } from '../supabase/client';
import { ladeDateiBlob } from '../dokumente/aktenschrankApi';
import { fuegePdfZusammen } from './pdfZusammen';
import { anzeigeBetreff } from './wiedervorlage';

export interface DruckEintrag {
  id: string; name: string; betreff: string; einschreiben: string; schriftform: boolean;
  dateiId: string | null; seit: string;
}

interface Roh {
  id: string; name: string | null; ablage_datei_id: string | null; druck_datei_id?: string | null; aktualisiert_at: string; werte?: Record<string, string> | null;
  schreiben: { betreff: string | null; eingaben?: Record<string, string> | null; optionen: { einschreiben?: string; schriftform?: boolean } | null } | null;
}

export function druckEintrag(z: Roh): DruckEintrag {
  return {
    id: z.id, name: z.name ?? '–', betreff: anzeigeBetreff(z.schreiben?.betreff ?? '', z.schreiben?.eingaben ?? {}, [z.werte ?? {}]), einschreiben: z.schreiben?.optionen?.einschreiben ?? '',
    schriftform: z.schreiben?.optionen?.schriftform === true, dateiId: z.druck_datei_id ?? z.ablage_datei_id, seit: z.aktualisiert_at,
  };
}

/** Offene Druckaufträge, älteste zuerst. null = Migration Etappe 3 fehlt noch. */
export async function ladeDruckstapel(): Promise<DruckEintrag[] | null> {
  const { data, error } = await supabase.from('schreiben_empfaenger')
    .select('id, name, ablage_datei_id, druck_datei_id, aktualisiert_at, werte, schreiben:schreiben_id(betreff, eingaben, optionen)')
    .eq('druck_gesendet', true).is('druck_erledigt_at', null).order('aktualisiert_at').limit(200);
  if (error) return null;
  return ((data ?? []) as unknown as Roh[]).map(druckEintrag);
}

/** Ist die Migration Etappe 3 eingespielt? Vorher sind Druck und Schriftform nicht wählbar (Prüfregel der Wege). */
export async function hatDruckstapel(): Promise<boolean> {
  const { error } = await supabase.from('schreiben_empfaenger').select('druck_gesendet').limit(1);
  return !error;
}

/** Die abgelegten PDFs als ein PDF (Reihenfolge wie übergeben) – zum Öffnen und Drucken im Browser. */
export async function druckPdf(eintraege: DruckEintrag[]): Promise<Blob> {
  const ohne = eintraege.filter((e) => !e.dateiId);
  if (ohne.length) throw new Error(`Keine abgelegte Datei: ${ohne.map((e) => e.name).join(', ')}`);
  const teile = [];
  for (const e of eintraege) teile.push({ bytes: new Uint8Array(await (await ladeDateiBlob(e.dateiId!, 'application/pdf')).arrayBuffer()), mime: 'application/pdf' });
  const bytes = await fuegePdfZusammen(teile);
  return new Blob([bytes as BlobPart], { type: 'application/pdf' });
}

/** Abhaken – versandt (bei Einschreiben mit Sendungsnummer). */
export async function markiereErledigt(id: string, sendungsnummer: string | null): Promise<void> {
  const { data: { user } } = await supabase.auth.getUser();
  const { error } = await supabase.from('schreiben_empfaenger')
    .update({ druck_erledigt_at: new Date().toISOString(), druck_erledigt_von: user?.id ?? null, sendungsnummer: sendungsnummer?.trim() || null })
    .eq('id', id).is('druck_erledigt_at', null);
  if (error) throw new Error(error.message);
}
